import React from "react";
import { Col, Row } from "reactstrap";
import TotalSupport from "./Widgets/TotalSupport";
import SalaryScale from "./Widgets/SalaryScale";
import GovernmentRequests from "./Widgets/GovernmentRequests";
import NumberOfMdas from "./Widgets/NumberOfMdas";

const Widget = () => {
  return (
    <Row>
      <Col xl={3} md={6}>
        <TotalSupport />
      </Col>
      <Col xl={3} md={6}>
        <NumberOfMdas />
      </Col>
      <Col xl={3} md={6}>
        <SalaryScale />
      </Col>
      <Col xl={3} md={6}>
        <GovernmentRequests />
      </Col>
    </Row>
  );
};

export default Widget;
